import React from 'react';
import { Route, Switch } from 'react-router';
import cn from 'classnames';
import TimeOffHeader from 'timeOffReports/components/TimeOffHeader.component';
import TipsHrLayout from 'timeOffReports/components/TipsHrLayout.component';

import KpiSummary from 'components/kpi/KpiSummary.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import ReportsTimeOffPage from 'components/timeoff/ReportsTimeOffPage.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import TopNav from 'common/TopNav.component';

import CN from './StaffReportsRoutes.module.scss';

const StaffReportsRoutes = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="TimeOffRoutes"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <TopNav title={t('staffKpisReports.pageTitle')}>
        <SidebarMenu />
      </TopNav>

      <TimeOffHeader />

      <Switch>
        <Route path={LINK.slnStaffReportsKpi} component={KpiSummary} />
        <Route path={LINK.slnStaffReportsTips} component={TipsHrLayout} />
        <Route path={LINK.slnStaffReportsTimeoff} component={ReportsTimeOffPage} />
      </Switch>
    </div>
  );
};

export default StaffReportsRoutes;
